import * as React from 'react';

import Config from '../../../FocusManager/Config';
import noop from '../../../Shared/Util/noop';

import IFocusableContextProps from './Interfaces/IFocusableContextProps';
import fallbackFocusManagerFacade from './Util/fallbackFocusManagerFacade';

/**
 * A root-level context providing all focusable nodes with the ability to communicate with the
 * `FocusableProvider`.
 */

const FocusableContext = React.createContext<IFocusableContextProps>({
    changeVirtualFocus: noop,
    config: new Config(),
    focusManagerFacade: fallbackFocusManagerFacade,
    handleClick: noop,
    handleNativeBlur: noop,
    handleNativeFocus: noop,
    registerFocusable: noop,
    reorderFocusableChildren: noop,
    unregisterFocusable: noop,
});

export default FocusableContext;
